import EventTrackingRealTimeEventsMixin from "./eventTrackingRealTimeEventsMixin";
import EventTrackingTdvEventsMixin from "./eventTrackingTdvEventsMixin";
import EventTrackingTdvMetricsMixin from "./eventTrackingTdvMetricsMixin";


/* Creates a new instance of a Brochure Tracking Event to track users events when the user subimits a lead.
 this class contains all the events that needs be to be done.
*/
export default class InformationTrackingEvents {
    constructor(model) { 
      const data = {...model, eventLabel: 'Search-CTA-Free-Brochure'}
      this.events = {};
      this.events.googleAnalytics = [
        new EventTrackingTdvEventsMixin(data),
        new EventTrackingTdvMetricsMixin(data),
        new EventTrackingRealTimeEventsMixin(data)];
    }
  }